import V2IconsAmbulance from '~/components/v2/icons/Ambulance.vue'
import V2IconsBriefcase from '~/components/v2/icons/Briefcase.vue'
import V2IconsChartLine from '~/components/v2/icons/ChartLine.vue'
import V2IconsCigarette from '~/components/v2/icons/Cigarette.vue'
import V2IconsFirstAid from '~/components/v2/icons/FirstAid.vue'
import V2IconsHandHeart from '~/components/v2/icons/HandHeart.vue'
import V2IconsHardHat from '~/components/v2/icons/HardHat.vue'
import V2IconsHeartBeat from '~/components/v2/icons/HeartBeat.vue'
import V2IconsMoney from '~/components/v2/icons/Money.vue'
import V2IconsPeace from '~/components/v2/icons/Peace.vue'
import V2IconsShield from '~/components/v2/icons/Shield.vue'
import V2IconsUser from '~/components/v2/icons/User.vue'
import V2IconsUserFour from '~/components/v2/icons/UserFour.vue'

const link = ({
  url,
  text,
  origin = 'https://compareclub.com.au/life-insurance'
} = {}) => {
  if (!text) {
    return ''
  }

  const path = `${origin}/${url || ''}`

  return `
    <a
      class="underline font-bold inline-block"
      target="_blank"
      href="${path}"
      rel="noopener"
    >
      ${text}
    </a>
  `
}

export const GREAT_DEAL_ITEMS = [
  {
    title: 'Life Cover',
    description:
      'Life insurance can help<br class="hidden lg:inline" /> protect your loved ones\'<br class="hidden lg:inline" /> financial future with<br class="hidden lg:inline" /> a lump sum payout if you<br class="hidden lg:inline" /> pass away or are diagnosed<br class="hidden lg:inline" /> with a terminal illness.',
    icon: `${APP_ASSET_BASEURL}edge/static/images/products/life/life-cover.svg`,
    iconDimensions: {
      width: 64,
      height: 64
    },
    url: '/life-insurance/what-is-life-insurance/',
    ctaBtnLabel: 'Learn more'
  },
  {
    title: 'Income Protection Insurance',
    description:
      'Income protection insurance<br class="hidden lg:inline" /> can pay up to 70% of your<br class="hidden lg:inline" /> salary if you are unable to<br class="hidden lg:inline" /> work due to injury or illness.',
    icon: `${APP_ASSET_BASEURL}edge/static/images/products/life/income-protection-insurance.svg`,
    iconDimensions: {
      width: 64,
      height: 64
    },
    url: '/life-insurance/income-protection-insurance/',
    ctaBtnLabel: 'Learn more'
  },
  {
    title: 'Total & Permanent Disablement Insurance',
    description:
      'Claim a lump sum to help<br class="hidden lg:inline" /> with your finances if you<br class="hidden lg:inline" /> become permanently unable to work again due<br class="hidden lg:inline" /> to an illness or injury.',
    icon: `${APP_ASSET_BASEURL}edge/static/images/products/life/total-permanent-disablement-insurance.svg`,
    iconDimensions: {
      width: 64,
      height: 64
    },
    url: '/life-insurance/tpd-insurance/',
    ctaBtnLabel: 'Learn more'
  },
  {
    title: 'Trauma (Critical Illness) Insurance',
    description:
      'Claim a lump sum to help<br class="hidden lg:inline" /> with your finances if you\'re<br class="hidden lg:inline" /> diagnosed with a critical<br class="hidden lg:inline" /> illness that is included in the insurer policy.',
    icon: `${APP_ASSET_BASEURL}edge/static/images/products/life/trauma-insurance.svg`,
    iconDimensions: {
      width: 64,
      height: 64
    },
    url: '/life-insurance/trauma-insurance/',
    ctaBtnLabel: 'Learn more'
  }
]

export const GREAT_DEAL_ITEMS_V2 = [
  {
    title: 'Life Cover',
    description:
      'Life cover (sometimes called death cover) is the one that pays out to your loved ones when you die.',
    icon: V2IconsHeartBeat,
    url: '/life-insurance/what-is-life-insurance/',
    ctaBtnLabel: 'Learn more'
  },
  {
    title: 'Income Protection Insurance',
    description:
      'This is the one that covers up to 70% of your income if you can’t work due to serious injury or illness (including mental health conditions) so you can concentrate on getting better again without worrying about money.',
    icon: V2IconsShield,
    url: '/life-insurance/income-protection-insurance/',
    ctaBtnLabel: 'Learn more'
  },
  {
    title: 'Total & Permanent Disability',
    description:
      'This is the one that pays you a lump sum if you can’t work again due to permanent disability. You might have heard about Disability Cover? Same thing.',
    icon: V2IconsAmbulance,
    url: '/life-insurance/tpd-insurance/',
    ctaBtnLabel: 'Learn more'
  },
  {
    title: 'Trauma (Critical Illness) Insurance',
    description:
      'This one pays you a lump sum amount (while you\'re living) for critical conditions like cancer or heart attacks.',
    icon: V2IconsFirstAid,
    url: '/life-insurance/trauma-insurance/',
    ctaBtnLabel: 'Learn more'
  }
]

export const SAVING_PLAN_ITEMS = [
  {
    title: 'Get peace of mind',
    description:
      'You and your family shouldn\'t have the added worry of financial stress if you get seriously ill, injured or worse. When you choose to buy life insurance, you get peace of mind that your loved ones will get financial support, in the event you pass away or become terminally ill.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/life/peace-of-mind.svg`,
    sectionImageDimensions: {
      width: 103.28,
      height: 80
    }
  },
  {
    title: 'Covers debts and major expenses',
    description:
      'What would happen to your family if your wage disappeared? Life insurance is designed to provide you and your family with a financial safety net to help pay for your living expenses.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/life/debts-major-expenses-cover.svg`,
    sectionImageDimensions: {
      width: 89.33,
      height: 80
    }
  },
  {
    title: 'Makes up for lost income',
    description:
      'Life insurance can help cover everyday expenses if you can\'t work because of illness or injury, even if it\'s just temporary. We’ll help you compare life insurance quotes so you can find a policy that keeps your bank balance healthy while you\'re recovering.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/life/lost-income.svg`,
    sectionImageDimensions: {
      width: 107.85,
      height: 80
    }
  },
  {
    title: 'Medical expenses',
    description:
      'Recovering from a serious medical condition is stressful enough without worrying about medical bills. A life policy payout can help get you back on your feet by covering the cost of major medical expenses.',
    sectionImage: `${APP_ASSET_BASEURL}edge/static/images/products/life/medical-expenses.svg`,
    sectionImageDimensions: {
      width: 94.9,
      height: 80
    }
  }
]

export const SAVING_PLAN_ITEMS_V2 = [
  {
    title: 'Peace of mind',
    description:
      'You and your loved ones have better things to do during your recovery (or not) from illness or injury than worrying about money. That\'s what life insurance is for.',
    icon: V2IconsPeace,
    iconProps: {
      width: 40,
      height: 40
    }
  },
  {
    title: 'Covers debts and major expenses',
    description:
      'Over a third of Australians have less than a week’s savings. <a class="underline font-bold text-semantic-primary-default" target="_blank" href="https://mccrindle.com.au/article/topic/work-wellbeing/the-1-regret-most-australians-have-about-their-finances/">Over half won\'t manage for more than a few weeks without working.*</a> What would happen to you and your family if you couldn\'t cover your living costs due to illness or injury? That\'s what life insurance is for.',
    icon: V2IconsMoney,
    iconProps: {
      width: 40,
      height: 40
    }
  },
  {
    title: 'Makes up for lost income',
    description:
      'Everyday expenses don\'t stop just because you get hurt or sick. You still have to keep the lights on, home paid for, and the kids in school. That\'s what life insurance is for.',
    icon: V2IconsChartLine,
    iconProps: {
      width: 40,
      height: 40
    }
  },
  {
    title: 'Medical expenses',
    description:
      'Additional costs are the last you need when you\'re getting your physical and mental health back on track - but this does cost money. Specialists, physical therapies, counselors, etc. How will you and your loved ones manage? That what life insurance is for.',
    icon: V2IconsHeartBeat,
    iconProps: {
      width: 40,
      height: 40
    }
  }
]

export const GUIDES_ITEMS = [
  {
    title: 'Find affordable life cover for over 50s',
    content:
      'Turning 50 shouldn\'t mean good life cover is beyond your budget. Here\'s how older Australians can find affordable life policies.',
    imageUrl: `${APP_ASSET_BASEURL}edge/static/images/products/life/cover-over-50-v2.png`,
    pageUrl: '/life-insurance/over-50s/',
    imageDimensions: {
      width: 300,
      height: 165
    }
  },
  {
    title: 'Life insurance for smokers',
    content:
      'Smokers can still get life insurance. Find out what it\'ll cost and how quitting can cut down your premiums.',
    imageUrl: `${APP_ASSET_BASEURL}edge/static/images/products/life/smokers-v2.png`,
    pageUrl: '/life-insurance/smokers/',
    imageDimensions: {
      width: 30,
      height: 165
    }
  },
  {
    title: 'Life insurance and pre-existing conditions',
    content:
      'Many insurers will still cover Australians even if they have pre-existing conditions. Here\'s what you need to know.',
    imageUrl: `${APP_ASSET_BASEURL}edge/static/images/products/life/pre-existing-conditions-v2.png`,
    pageUrl: '/life-insurance/pre-existing-conditions/',
    imageDimensions: {
      width: 300,
      height: 165
    }
  }
]

export const FAQ_ITEMS = [
  {
    title: 'When’s the best time to take out life cover?',
    content: `
      <p>
        Most people tend to get life insurance when they get their first mortgage, get married or have a baby or when other life significant events occur.
      </p>
    `
  },
  {
    title: 'How is my life cover premium calculated?',
    content: `
      <p>
        Your life insurance contract is based on your circumstances when your policy starts, so if your health changes AFTER that, your policy is not affected.
      </p>
    `
  },
  {
    title: 'Can my job affect my life cover premium?',
    content: `
      <p>
        Yes it can. If you change occupation to a lower risk job you may be able to apply for lower rates for Total and Permanent Disability (TPD) and Income Protection cover.
      </p>
    `
  }
]

export const FAQ_ITEMS_COMPARISON = [
  {
    title: 'Why do I need life insurance ?',
    content: `
      <p>
        Dealing with a death or serious illness in the family is difficult enough without the added strain that comes with a loss of income. Life insurance is a financial security if a loved one dies or becomes unable to work. That’s why life insurance is so important. In addition to helping support dependents and help meet financial obligations, life insurance cover also provides a funeral benefit which is an inbuilt feature in life cover policies.
      </p>
    `
  },
  {
    title:
      'My kids are all adults and my house has been paid off, so what do I need life insurance for?',
    content: `
      <p>
        Paying off a mortgage could be one of the greatest achievements in a person’s life. However, it is important to keep in mind that although the mortgage has been paid off, the daily living expenses is an ongoing expense that continues for the rest of a person’s life. Cost of owning a car/cars, groceries, health expenses, and household bills are just some of the things which constitute a part of general living expenses.
      </p>
    `
  },
  {
    title: 'How much should I cover myself for?',
    content: `
      <p>
        Dealing with a death or serious illness in the family is difficult enough without the added strain that comes with a loss of income. Life insurance is a financial security if a loved one dies or becomes unable to work. That’s why life insurance is so important. In addition to helping support dependents and help meet financial obligations, life insurance cover also provides a funeral benefit which is an inbuilt feature in life cover policies.
      </p>
    `
  },
  {
    title: 'How much will my premium cost?',
    content: `
      <p>
        This depends on a number of factors; age, smoking status, state, occupation, and levels of cover. Our expert <a href="/life-insurance/quote/form/step1/" class="underline">life insurance specialist</a> will be able to guide you in the right direction to make sure you get the most cost-effective cover available.
      </p>
    `
  },
  {
    title: 'What\'s the difference between age-stepped and variable premiums?',
    content: `
      <p>
        <a href="/life-insurance/cost/" class="underline">Age-stepped premiums</a> are your traditional premium style that increase every year as you get older. <a href="/life-insurance/cost/" class="underline">Variable premiums</a> usually do not change as you age but is generally more expensive than a age-stepped premium in the beginning. Variable premiums may increase over time due to inflation (which you can opt-out of) or changes to the insurer’s fees, but these will be smaller increases than a age-stepped premium.
      </p>
    `
  },
  {
    title: 'Is there a discount for signing up as a couple?',
    content: `
      <p>
        Unfortunately, no. Each person is given their own price depending on their variables like age, smoking status, occupation etc.
      </p>
    `
  },
  {
    title: 'Can I still get life insurance if I have existing health issues?',
    content: `
      <p>
        Yes you can, but it all depends on what the health issue is. Our expert specialists will be able to tell you if you can get cover and whether there will be any changes to the policy cost.
      </p>
    `
  },
  {
    title: 'I quit smoking a while ago, can I get Life Insurance?',
    content: `
      <p>
        <a href="/life-insurance/smokers/" class="underline">Being a smoker doesn’t mean you can’t get coverage.</a> Your premium will be a bit higher than the premium for someone who doesn’t smoke, but it is more affordable than you may think. Also, most insurance companies consider you a non-smoker if you’ve stayed away from cigarettes for at least a year.
      </p>
    `
  },
  {
    title: 'What is covered in Income protection?',
    content: `
      <p>Each applicant is assessed individually however some key features of income<br> protection are:</p>
      <ul class="list-outside list-disc">
        <li>
          Replaces up to 70% of your gross income if you are unable to work due to injury or sickness.
        </li>
        <li>
          Mental illness can be considered for a payout depending on the insurer and
            <a href="/life-insurance/pre-existing-conditions/" class="underline">pre-existing</a> mental health-related conditions.
        </li>
        <li>
          Needlestick injury cover can be obtained for certain professionals working in the medical industry.
        </li>
        <li>
          The payout can be claimed for partial disability as well, allowing the insured to continue working a certain number of hours. This varies across each insurer.
        </li>
      </ul>
    `
  },
  {
    title: 'What are the different types of Life insurance?',
    content: `
      <p>The 4 different types of Life Insurance cover are:</p>
      <ul class="list-decimal list-outside">
        <li>
          <a href="/life-insurance/what-is-life-insurance/" class="underline">Life Insurance</a> – Term life insurance is also known as life cover, death cover, or simply life insurance. It pays out a lump sum to your nominated beneficiary if you pass away. In the event the insured is unfortunate enough to be diagnosed with a terminal illness with a life expectancy of 12-24 months, then the insurer will pay the lump sum amount to the life insured to help set any affairs in order before passing away.
        </li>
        <li>
          <a href="/life-insurance/trauma-insurance/" class="underline">Trauma</a> – Provides a lump sum payment to the insured if they are diagnosed with a specified illness such as stroke or cancer.
        </li>
        <li>
          <a href="/life-insurance/tpd-insurance/" class="underline">Total &amp; Permanent Disability</a> – Total and permanent disability insurance (TPD) policy is designed to lift financial pressure off you, should an illness or injury leave you completely or permanently disabled and unable to work.
        </li>
        <li>
          <a href="/life-insurance/income-protection-insurance/" class="underline">Income Protection</a> – Income protection generally provides you with monthly payments that replace up to 70 percent of your monthly income should you find yourself unable to work due to injury or illness.
        </li>
      </ul>
    `
  },
  {
    title: 'Are there any age-related cut-offs ?',
    content: `
      <p>
        This varies depending on a number of factors. Life cover is not available after age 75 but if you have an existing policy, you can be covered till your 99th birthday.
      </p>
    `
  },
  {
    title: 'Who is a beneficiary?',
    content: `
      <p>
        <a href="/life-insurance/beneficiary/" class="underline">A life insurance beneficiary</a> is the person, persons, or organisation that receives your life insurance payout. You can decide who should receive these funds. Review your life insurance beneficiary regularly as you may wish to change it if your circumstances have changed.
      </p>
    `
  },
  {
    title: 'How are claims paid out?',
    content: `
      <p>
        A nominated beneficiary (the person that the claim payments are paid to when the claim is processed and approved) can start by contacting us as soon as possible, so we can support you for making your claim. We recommend you to have all your documentation ready with any certification completed, if required. <a href="/life-insurance/claim/" class="underline">Please click here to read more</a>
      </p>
    `
  }
]

export const PARTNER_ITEMS = [
  {
    company: 'AIA.svg'
  },
  {
    company: 'OnePath.svg'
  },
  {
    company: 'TAL.svg'
  },
  {
    company: 'MLC.svg'
  },
  {
    company: 'ClearView.svg'
  },
  {
    company: 'Zurich.svg'
  }
]

export const SITE_LINKS = [
  {
    icon: V2IconsUser,
    title: 'Life Insurance For Seniors',
    url: '/life-insurance/over-65/',
    desc: 'The cutoff age for getting a new life insurance policy can be as high as 75 years. If you already have cover, find out of you can save by switching to a cheaper premium.'
  },
  {
    icon: V2IconsUserFour,
    title: 'Life Insurance For Families',
    url: '/life-insurance/families/',
    desc: 'Your family still needs you, even when you\'re hurt or sick - or worse. Taking care of your children and partner - no matter what - is why most parents take out life insurance, especially if there\'s a family history or critical illness like cancer or heart attacks.'
  },
  {
    icon: V2IconsCigarette,
    title: 'Life Insurance For Smokers',
    url: '/life-insurance/smokers/',
    desc: 'If you have tried for life insurance before and been knocked back as a smoker, talk to us - especially if you\'ve recently quit.'
  },
  {
    iconProps: {
      height: 40,
      width: 40
    },
    icon: V2IconsBriefcase,
    title: 'Life Insurance when you\'re Self-Employed',
    url: '/life-insurance/trauma-insurance/',
    desc: 'We know you can\'t afford to get sick or hurt when you\'re running your own business - especially if you have employees - which is why 60% have some form of life insurance for contingencies. Life insurance is how you protect what you\'ve worked so hard to acheive.'
  },
  {
    icon: V2IconsHardHat,
    title: 'Life Insurance for High Risk Jobs',
    url: '/life-insurance/income-protection-insurance/',
    desc: 'Working construction? Outdoors? On the road a lot? The higher the risk of illness or injury, the safer you are with some sort of backup plan.'
  },
  {
    icon: V2IconsHandHeart,
    title: 'Life Insurance and your Mental Health',
    url: '/life-insurance/tpd-insurance/',
    desc: 'Life insurance can cover mental health conditions like depression and anxiety as well. Find out which policies include cover for these increasingly common health concerns - and which don\'t.'
  }
]

export const GLOSSSARY_LIST = [
  {
    title: 'B-H',
    content: `
      <p class="mb-4">
        <strong>Beneficiary:</strong> The person or entity you choose to receive any of your payable benefits, in the event a covered incident occurs. Note: in a case of critical illness or total and permanent disability, the beneficiary is usually you but you can nominate someone else. In the case of your death, any benefit payment will go to your chosen person, or organisation. Key points about beneficiaries include:
      </p>
      <p class="mb-4">
        - Designation: You can choose your own beneficiary. It can be your spouse, child, family member, friend, trust, or even a charitable organisation. You’re able to select multiple beneficiaries and specify the percentage or amount each should receive.
      </p>
      <p class="mb-4">
        - Primary and Contingent Beneficiaries: Your primary beneficiary is the first person or entity entitled to receive the death benefit. If your primary beneficiary predeceases you, or is unable to receive the benefit, your contingent beneficiary, also known as yout secondary beneficiary, will receive your benefit. Contingent beneficiaries are often named as backups to ensure your death benefit goes to your intended recipients.
      </p>
      <p class="mb-4">
        - Change of Beneficiary: Typically, you have the right to change your beneficiary/ies at any stage of your life cover. It's important to keep this information up to date, reflecting any changes in circumstances, such as marriage, divorce, or the birth of your children.
      </p>
      <p class="mb-4">
        - Irrevocable Beneficiary: In some cases, you may choose to designate your beneficiary as "irrevocable." This means that you can’t change your beneficiary without their written consent. It's important to carefully consider the implications of an irrevocable beneficiary designation, as it limits your flexibility.
      </p>
      <p class="mb-4">
        - Your Estate as Beneficiary: If you name your estate as your beneficiary, your death benefit becomes part of your estate and can be subject to estate taxes and creditors' claims. Naming specific individuals or entities as beneficiaries can avoid these complications.        
      </p>

      <p class="mb-4">
        <strong>Charitable Giving:</strong> Life insurance can also be used to create a legacy by designating a charitable organization as a beneficiary. This allows individuals to support causes or organizations that are important to them, leaving a lasting impact beyond their lifetime.
      </p>

      <p class="mb-4">
        <strong>Death Benefit:</strong> The amount of money paid by your insurance company to your beneficiary/ies upon your death. It’s typically a tax-free lump sum.
      </p>

      <p class="mb-4">
        <strong>Death Cover:</strong> Death cover, also known as death benefit or life cover, is the fundamental component of a life insurance policy. It pays out a lump sum to your designated beneficiaries upon your death. Your death benefit is typically paid out to help your beneficiaries cover expenses such as funeral costs, outstanding debts, medical costs, mortgage payments, education expenses, and day-to-day living expenses.
      </p>

      <p class="mb-4">
        <strong>Exclusion:</strong> Specific circumstances, conditions, or events that aren’t covered by your insurance policy. Exclusions vary between policies, and it's essential to review them carefully before purchasing a policy.
      </p>      
    `
  },
  {
    title: 'I-R',
    content: `
      <p class="mb-4">
        <strong>Income Protection Insurance:</strong> Also known as salary continuance insurance, income protection provides a replacement income if you’re unable to work due to illness or injury. It usually pays out around 70% of your regular income for a specified period.
      </p>

      <p class="mb-4">
        <strong>Legatee:</strong> A legatee refers to an individual or entity named in your Will or trust to receive a specific bequest or gift. In the context of life cover, your legatee can also be your payout beneficiary.
      </p>

      <p class="mb-4">
        Key points about legatees include:
      </p>
      
      <ol class="mb-4">
        <li class="mb-4">a. Bequest Designation: A legatee is typically designated in a legal document such as a will or trust. The insured person, as the policyholder, has the discretion to name one or more legatees as beneficiaries of their life insurance policy.</li>
        <li class="mb-4">b. Specific Bequest: Unlike primary and contingent beneficiaries, who may receive a share of the overall death benefit, a legatee is typically named to receive a specific bequest or gift. This could be a fixed amount of money, a particular asset, or a percentage of the estate.</li>
        <li class="mb-4">c. Importance of Proper Documentation: To ensure that the life insurance proceeds are distributed according to the insured person's wishes, it is crucial to clearly and accurately designate legatees in the appropriate legal documents. This helps avoid confusion or disputes regarding the distribution of assets.</li>
        <li>d. Relationship to Estate Planning: Legatees play a significant role in estate planning and the distribution of assets after an individual's passing. They may be family members, friends, charitable organizations, or any other entity the insured person wishes to benefit.</li>
      </ol>

      <p class="mb-4">
        <strong>Life Insurance, also known as Death Cover:</strong> A contract between you and your insurance company, where the insurer agrees to pay out a specific amount of money in the event of your death (i.e., your death benefit), to your beneficiaries when you die.
      </p>

      <p class="mb-4">
        <strong>Policyholder:</strong> The individual who purchased and owns the life insurance policy (i.e. you). You may also be referred to as ‘the insured’.
      </p>

      <p class="mb-4">
        <strong>Premium:</strong> The amount of money you pay to your insurance company to maintain your cover. Premiums can be paid monthly, quarterly, annually, or in some other agreed-upon frequency.
      </p>
    `
  },
  {
    title: 'S-W',
    content: `
      <p class="mb-4">
        <strong>Total and Permanent Disability (TPD) Cover:</strong> TPD cover pays a lump sum benefit if you become totally and permanently disabled and can’t work ever again in your own or any occupation for which you’re reasonably suited based on education, training, and/or experience.
      </p>

      <p class="mb-4">
        <strong>Trauma Cover:</strong> Also referred to as critical illness insurance, trauma cover provides a lump sum payment if you’re diagnosed with a specified critical illness, or you experience a major medical event. Examples of covered conditions include cancer, heart attack, stroke, or a major organ transplant.
      </p>

      <p class="mb-4">
        <strong>Underwriting:</strong> This is the process where your insurance company evaluates your risk profile, including your health, occupation, lifestyle, and medical history. This is done to determine whether you will be offered cover, and the price of your insurance premium. <strong class="italic">*please note: that conditions may apply depending on your policy</strong>
      </p>

      <p class="mb-4">
        <strong>Waiting Period:</strong> In life insurance, the waiting period refers to the specified period of time that must elapse after the policy's inception or a claimable event before the policyholder becomes eligible to receive certain benefits.
      </p>
      
      <p class="mb-4">Key points about waiting periods in life insurance include:</p>
      
      <ol class="mb-4">
        <li class="mb-4">
          a. Duration: The waiting period can vary depending on the terms and conditions of the life insurance policy. It is typically defined in terms of days, weeks, or months. Common waiting period durations range from 30 days to six months, but they can be longer or shorter depending on the specific policy.
        </li>
        <li class="mb-4">
          b. Claimable Events: The waiting period often applies to specific events or conditions. For example, in the case of a life insurance policy, the waiting period might be triggered by a claim for certain critical illnesses or total and permanent disability benefits. During the waiting period, the policyholder is not eligible to receive these particular benefits even if the triggering event occurs.
        </li>
        <li class="mb-4">
          c. Exclusions: It's important to review the policy's terms and conditions to understand any exclusions or limitations.. Certain events or conditions may be explicitly excluded from coverage, or there may be specific waiting periods for different benefits within the same policy.
        </li>
        <li class="mb-4">
          d. Premium Payments: It's worth noting that premium payments are typically required during the waiting period, even though the policyholder may not be eligible for certain benefits during that time. Regular premium payments ensure that the policy remains active and in force until the term expires or for as long as you choose to keep it.
        </li>
      </ol>

      <p class="mb-4">
        <strong>Waiting Period:</strong> The initial period after your illness or injury occurs, during which you must be unable to work before you’re entitled to any benefit payments under an income protection policy. This can be an important factor when selecting a policy, and an insurer.
      </p>

      <p class="mb-4">
        <strong>Wealth Preservation:</strong> Life insurance can be used as a tool for preserving wealth and passing it on to future generations. By providing liquidity to cover estate settlement costs, such as taxes or legal fees, life insurance can help ensure that the intended beneficiaries receive the full value of the estate.
      </p>
    `
  }
]

export const COMPARISON_TABLE_DATA = {
  '$1 Million Cover': {
    '45 Years Old': {
      'Male - Daily Premium': '$1.36',
      'Male - Monthly Premium': '$40.89',
      'Female - Daily Premium': '$1.11',
      'Female - Monthly Premium': '$33.44'
    },
    '50 Years Old': {
      'Male - Daily Premium': '$2.41',
      'Male - Monthly Premium': '$72.39',
      'Female - Daily Premium': '$1.78',
      'Female - Monthly Premium': '$53.50'
    },
    '55 Years Old': {
      'Male - Daily Premium': '$4.99',
      'Male - Monthly Premium': '$146.73',
      'Female - Daily Premium': '$3.47',
      'Female - Monthly Premium': '$104.04'
    },
    '60 Years Old': {
      'Male - Daily Premium': '$11.83',
      'Male - Monthly Premium': '$330.87',
      'Female - Daily Premium': '$7.44',
      'Female - Monthly Premium': '$233.08'
    },
    '65 Years Old': {
      'Male - Daily Premium': '$23.00',
      'Male - Monthly Premium': '$690.03',
      'Female - Daily Premium': '$15.52',
      'Female - Monthly Premium': '$465.57'
    }
  },
  '$2 Million Cover': {
    '45 Years Old': {
      'Male - Daily Premium': '$2.71',
      'Male - Monthly Premium': '$81.19',
      'Female - Daily Premium': '$2.10',
      'Female - Monthly Premium': '$62.85'
    },
    '50 Years Old': {
      'Male - Daily Premium': '$4.79',
      'Male - Monthly Premium': '$143.76',
      'Female - Daily Premium': '$3.41',
      'Female - Monthly Premium': '$102.28'
    },
    '55 Years Old': {
      'Male - Daily Premium': '$9.71',
      'Male - Monthly Premium': '$291.38',
      'Female - Daily Premium': '$6.63',
      'Female - Monthly Premium': '$198.91'
    },
    '60 Years Old': {
      'Male - Daily Premium': '$20.59',
      'Male - Monthly Premium': '$617.62',
      'Female - Daily Premium': '$14.32',
      'Female - Monthly Premium': '$429.68'
    },
    '65 Years Old': {
      'Male - Daily Premium': '$42.94',
      'Male - Monthly Premium': '$1,288.08',
      'Female - Daily Premium': '$28.97',
      'Female - Monthly Premium': '$869.07'
    }
  }
}

export const WHY_GET_LIFE_INSURANCE = {
  'Retail life insurance': {
    'Ownership structure':
      'Different ownership structures available to individuals including: <br class="hidden lg:block" />Self ownership, Joint ownership, Cross ownership',
    'Policy options':
      'Retail life insurance policies can be customized with additional options such as accidental death insurance & child cover',
    'Cover amount': 'Cover amount can be customised to fit your needs',
    Premiums:
      'Different premium types are available for a retail life insurance policy such as: Stepped, Level, Hybrid'
  },
  'Default life in super': {
    'Ownership structure':
      'Typically the owner of your policy will be the super fund or organisation that is funding your life',
    'Policy options':
      'Default life in super policies typically don’t allow customization. Your life cover will not be tailored to your particular requirements.',
    'Cover amount':
      'Default life in super policies typically have comparatively low cover amounts compared to retail life insurance policies.',
    Premiums:
      'Typically cheaper premiums than retail life insurance however you are limited in how you can tailor your cover. Premiums are directly taken from your superannuation account.'
  }
}

export const COMPARISON_HEADLINES = [
  'One of our specialists will give you a call to discuss your options. There’s no obligation to buy and our team are experts who can help you understand the different covers you need. As life insurance can be a bit complex, we’ll also email you with details of the types of policies available to you and what they mean.',
  'Don’t worry about paperwork. Once you’ve selected a policy you’re happy with, our team will take care of all the admin with the insurer on your behalf.',
  'Enjoy the peace of mind that comes with knowing you and your loved ones are protected with a fully medically underwritten life insurance policy.'
]

export const COMPARISON_EXTRA_FEATURES = [
  'Trauma cover requested',
  'Total & Permanent Disablement cover requested',
  'Multi-product discount',
  'Superlink with 15% discount',
  'Level premiums'
]
